import {
  RETRIEVE_CLASS_LIST,
  RETRIEVE_BASE_CLASS_LIST,
  CREATE_CLASS,
  GET_CLASS_INFO,
  EDIT_CLASS,
  DELETE_CLASS
} from '@/api'

import {GET_GRADE_BY_ID, CREATE_GRADE, UPDATE_GRADE, DELETE_GRADE, GET_LIST_GRADES, GET_GRADE_MASTER} from '@/api/phase2/grades'

export default {
  retrieveClassList({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.class_list.length) {
        commit('retrieveClassList', {classList: response.data.data.class_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_CLASS_LIST({}, successCallback, errorCallback)
  },

  createClass({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.class_info) {
        commit('addClassToList', {classList: response.data.data.class_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_CLASS({data: payload.data}, successCallback, errorCallback)
  },

  editClass({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.class_info) {
        commit('getClassInfo', {classInfo: response.data.data.class_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_CLASS({data: payload}, successCallback, errorCallback)
  },

  getClassInfo({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.class_info) {
        commit('getClassInfo', {classInfo: response.data.data.class_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_CLASS_INFO({payload}, successCallback, errorCallback)
  },

  deleteClass({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      commit('deleteClass', {classInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_CLASS({payload}, successCallback, errorCallback)
  },

  retrieveBaseClassList(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_BASE_CLASS_LIST(successCallback, errorCallback)
  },

  getGradeById ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_GRADE_BY_ID({ payload }, successCallback, errorCallback)
  },
  getListGrade ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_LIST_GRADES({ payload }, successCallback, errorCallback)
  },
  updateGrade ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    UPDATE_GRADE({ payload }, successCallback, errorCallback)
  },
  createGrade ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    CREATE_GRADE({ payload }, successCallback, errorCallback)
  },
  deleteGrade ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    DELETE_GRADE({ payload }, successCallback, errorCallback)
  },
  getGradeMaster ({ commit }, payload) {
    let errorCallback = (error) => {
      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback(error)
      }
    }
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_GRADE_MASTER({ payload }, successCallback, errorCallback)
  }
};
